import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { PurchasePopupComponent } from '../shared/components/purchase-popup/purchase-popup.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('fade', [
      transition('void => *', [ // using status here for transition
        style({ opacity: 0 }),
        animate(700, style({ opacity: 1 }))
      ]),
      transition('* => void', [
        animate(700, style({ opacity: 0 }))
      ])
    ])
  ]
})
export class HomeComponent implements OnInit {

  showCenter = true;
  showMain = false;

  timeout;

  constructor(public dialog: MatDialog) { }

  ngOnInit() {

    this.timeout = setTimeout(() => {
      this.proceed();
    }, 5000)
  }

  purchase() {
    let dialogRef = this.dialog.open(PurchasePopupComponent, {});
  }

  proceed() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.showCenter = false;
    setTimeout(() => {
      this.showMain = true;
    }, 700)
  }

}
